<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block>
          <router-link to="/refundPayment">
            <a-icon type="rollback" />&nbsp; Return
          </router-link>
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="loading.page" class="margin-bottom">
            <div slot="title">
              Refund Payment Manifest
              <small class="m-display-block m-text-small">{{
                data.header.no_trans
              }}</small>
            </div>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Date Created</span>
                  <span class="m-list-desc"
                    >{{
                      data.header.created_date
                        ? moment(
                            data.header.created_date,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        : "-"
                    }}
                  </span>
                </li>
                <li>
                  <span class="m-list-title" for>User Creator</span>
                  <span class="m-list-desc">{{
                    data.header.user_creator
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Transaction</span>
                  <span class="m-list-desc">{{
                    data.header.transaction
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Description</span>
                  <span class="m-list-desc">{{
                    data.header.description ? data.header.description : "-"
                  }}</span>
                </li>
              </ul>
            </div>
          </a-card>

          <a-collapse :class="getScreen ? 'margin-top' : ''" activeKey="1">
            <a-collapse-panel key="1">
              <h4 slot="header" class="margin-remove">Data Refund</h4>
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Receive From</span>
                  <span class="m-list-desc">{{
                    data.header.from
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Account From</span>
                  <span class="m-list-desc">{{
                    data.header.account_from ? data.header.account_from : "-"
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Currency From</span>
                  <span class="m-list-desc">{{
                    data.header.currency_from ? data.header.currency_from : "-"
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Date of Transfer</span>
                  <span class="m-list-desc">{{
                    data.header.date_of_transfer ? data.header.date_of_transfer : "-"
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Value Refund
                  </span>
                  <span class="m-list-desc">{{
                    data.header.currency_origin
                      ? formatCurrency(
                          data.header.currency_origin,
                          data.header.value_refund
                        )
                      : "-"
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Account To</span>
                  <span class="m-list-desc">{{
                    data.header.account_to ? data.header.account_to : "-"
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Currency To</span>
                  <span class="m-list-desc">{{
                    data.header.currency_to ? data.header.currency_to : "-"
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Kurs from {{data.header.currency_to}} to
                      {{data.header.currency_from}} 
                  </span>
                  <span class="m-list-desc">{{
                    data.header.currency_to
                      ? formatCurrency(
                          data.header.currency_to,
                          data.header.kurs
                        )
                      : "-"
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Value kurs</span>
                  <span class="m-list-desc">{{
                    data.header.currency_to
                      ? formatCurrency(
                          data.header.currency_to,
                          data.header.value_kurs
                        )
                      : "-"
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Evidence of Transfer</span>
                  <span class="m-list-desc margin-top">
                    <a-button
                      class="margin-top ant-menu-submenu ant-menu-submenu-selected"
                      icon="download"
                      size="default"
                      @click="handlePreview(data.header.file_path)"
                    >View Document</a-button>
                    
                  </span>
                </li>
              </ul>
          </a-collapse-panel>
          </a-collapse>

          <a-card v-if="getScreen && dtabel.length>0" style="overflow: auto" class="margin-top margin-bottom">
            <div slot="title">Details</div>
            <div class="m-card-body divOverflow">
              <!-- style="overflow: auto;"
              class="listOverflow"   style="overflow: auto;"-->
              <a-list
                item-layout="vertical"
                :data-source="dtabel"
                :pagination="pagination"
              >
                <a-list-item
                  slot="renderItem"
                  key="item.id_dtl"
                  slot-scope="item, index"
                >
                  <a-list-item-meta>
                    <div slot="title">
                      <p style="font-size: 14px">
                        {{index+1}}. {{ item.nm_barang }}<br />
                        PP Dtl :
                        <i
                          >({{ item.nama_item }} /
                          {{ item.kode_anggaran }})</i
                        >
                      </p>
                    </div>
                    <div slot="description" class="margin-remove">
                      <div class="m-display-flex space-between">
                        <span
                          >{{ item.jumlah }}&nbsp;{{ item.satuan }}</span
                        >
                        <div>
                          <h4 class="margin-remove m-text-align right">
                            @ {{ formatCurrency(data.header.currency_origin, item.harga) }}
                          </h4>
                        </div>
                      </div>
                      <!-- <h3 class="margin-remove m-text-align right">
                        Grand Total :
                        {{ formatCurrency(data.header.currency_origin, item.total_harga) }}
                      </h3> -->
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </div>
            <div class="m-price-total">
              <h3 class="margin-remove m-text-align right">
                Total : {{ formatCurrency(data.header.currency_origin, data.total.subTotal) }}
              </h3>
              <!-- <h3
                class="margin-remove m-text-align right"
              >TAX ({{pajak}}) : {{formatCurrency(currency,data.total.nilaiPajak)}}</h3>
              <h3 v-if="data.total.shipping"
                class="margin-remove m-text-align right"
              >Shipping Cost : {{formatCurrency(currency,data.total.shipping)}}</h3> -->

              <h3
                v-for="(item, index) in dlist"
                :key="index"
                class="margin-remove m-text-align right"
              >
                {{ item.nama_barang }}
                {{ item.persen !== null ? "(" + item.persen + "%) : " : " : " }}
                {{ item.kategori == "1" ? "-" : "" }}
                {{ formatCurrency(data.header.currency_origin, item.total_harga) }}
              </h3>
              
              <div style="display: flex;flex-direction: row-reverse">
                
                <!-- <h3 class="margin-remove m-text-align right" v-if="displaylistrefund">
                  Refund : {{ formatCurrency(data.header.currency_origin, data.total.refundTotal) }}
                </h3> -->

                <!-- <a-button
                style="margin-right: 10px"
                @click="handleViewclosetrans"
                type="default"
                icon="eye"
                size="small"
                >View</a-button> -->
              </div>

              <!-- <a-statistic
                title="Grand Total"
                :value="formatCurrency(currency, data.total.grandTotal)"
                class="m-text-align right"
              /> -->
            </div>
          </a-card>
          <a-collapse v-if="!getScreen && dtabel.length>0" class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <h4 slot="header" class="margin-remove">Details</h4>
              <a-input-search
                v-model="search"
                placeholder="Quick Search"
                allowClear
                class="margin-bottom"
              />
              <a-table
                :rowKey="(record, index) => {return index;}"
                :columns="columns"
                :dataSource="dtabel"
                :pagination="pagination"
                size="small"
                bordered
                :scroll="{ x: 950 }"
              >
                <span slot="no" slot-scope="text,record,index">
                  {{index+1}}
                </span>
                <span slot="item_PN" slot-scope="item_PN">
                  <b>{{ item_PN.nama_item }}</b
                  ><br />
                  {{
                    item_PN.item_pn || item_PN.item_pn !== ""
                      ? "PN : " +
                        (item_PN.item_pn == null ? "-" : item_PN.item_pn)
                      : ""
                  }}<br /><span v-if="item_PN.type_item">{{ "( "+item_PN.type_item +" )"}}<br /></span>
                </span>
                <span slot="ppdtl" slot-scope="ppdtl">
                  {{ ppdtl.nm_barang }}<br />
                  <i> {{ ppdtl.kode_anggaran }}</i>
                </span>
                <span slot="quantity" slot-scope="text,record">
                  {{record.jumlah}} {{record.satuan}}
                </span>
                <span slot="unit_price" slot-scope="unit_price">
                  <CurrencyJustified
                    :currencyValue="data.header.currency_origin"
                    :valueNumber="unit_price.harga === 0 ? 0.0 : unit_price.harga"
                  />
                </span>
                <span slot="amount" slot-scope="amount">
                  <CurrencyJustified
                    :currencyValue="data.header.currency_origin"
                    :valueNumber="amount.jumlah*amount.harga"
                  />
                </span>
                <div slot="footer" class="padding-all">
                  <a-row type="flex">
                    <a-col :span="5" :order="1" class="m-text-align left"
                      >Total</a-col
                    >
                    <a-col
                      :span="1"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                    </a-col>
                    <a-col
                      :span="6"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="data.header.currency_origin"
                        :valueNumber="data.total.subTotal"
                        :deci2="true"
                      />
                    </a-col>
                  </a-row>

                  <!-- <a-row
                    type="flex"
                    v-for="(item, index) in dlist"
                    :key="index"
                  >
                    <a-col :span="5" :order="1" class="m-text-align left">
                      {{ item.nama_item }}
                      {{ item.prosentase !== null ? "(" + item.prosentase + "%)" : "" }}
                    </a-col>
                    <a-col
                      :span="1"
                      :order="2"
                      class="m-text-align right m-text-bold"
                    >
                    </a-col>
                    <a-col
                      :span="6"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        v-if="item.harga"
                        :currencyValue="data.header.currency_origin"
                        :valueNumber="item.kategori=='1' ? item.harga*-1: item.harga"
                        :deci2="true"
                      />
                    </a-col>
                  </a-row>

                  <a-divider class="margin-small" /> -->
                  <!-- <a-row type="flex">
                    <a-col :span="5" :order="1" class="m-text-align left"
                      >Grand Total</a-col
                    >
                    <a-col
                      :span="1"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                    </a-col>
                    <a-col
                      :span="6"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="data.header.currency_origin"
                        :valueNumber="data.total.grandTotal"
                        :deci2="true"
                      />
                    </a-col>
                  </a-row> -->
                  <!-- <a-row type="flex" v-if="displaylistrefund">
                    <a-col :span="5" :order="1" class="m-text-align left"
                      >Refund</a-col
                    >
                    <a-col
                      :span="1"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    >
                    </a-col>
                    <a-col
                      :span="6"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        v-if="data.total.refundTotal"
                        :currencyValue="data.header.currency_origin"
                        :valueNumber="data.total.refundTotal"
                      />
                    </a-col>
                    <a-col
                      :span="6"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      &nbsp;
                      <a-button
                      @click="handleViewclosetrans"
                      type="default"
                      icon="eye"
                      size="small"
                      >View</a-button
                    >
                    </a-col>
                  </a-row> -->
                </div>
              </a-table>
            </a-collapse-panel>
          </a-collapse>

          <!-- <a-card
            class="margin-top"
            v-if="data.jenis === 'Transfer' && status_transfer"
          >
            <div slot="title">
              Manifest Actions &nbsp;<i
                v-if="data.jenis == 'Transfer' && !status_transfer"
                style="color: red !important"
                >(Funding has not been set)</i
              >
            </div>
            <div class="m-text-align right margin-remove" slot="extra">
              <h5 class="m-text-align right margin-remove">
                remaining balance
              </h5>
              <a-tag color="green" class="m-text-align right margin-remove">{{
                formatCurrency(currency, sisa_tf)
              }}</a-tag>
            </div>
            <template v-if="!(data.jenis == 'Transfer' && !status_transfer)">
              <a-form :form="form">
                <a-row :gutter="16">
                  <a-form-item label="Status">
                    <a-select
                      @change="onChangeStatus"
                      v-decorator="[
                        'status',
                        {
                          rules: [{ required: true }],
                          initialValue: data.aksi[0].aksi,
                        },
                      ]"
                    >
                      <a-select-option v-for="da in data.aksi" :key="da.aksi">{{
                        da.aksi
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Date">
                    <a-date-picker
                      placeholder="Select Date"
                      :format="dateFormat"
                      v-decorator="['tgl_tf', { rules: [{ required: true }] }]"
                    />
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Upload Bukti Transfer">
                    <a-upload
                      :fileList="fileList"
                      :disabled="fileList.length > 0"
                      v-decorator="[
                        'file_transfer',
                        { rules: [{ required: reqFileTf }] },
                      ]"
                      accept=".jpg, .png, .pdf"
                      :remove="handleRemove"
                      :beforeUpload="beforeUpload"
                    >
                      <a-button> <a-icon type="upload" />Select File </a-button>
                    </a-upload>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Value">
                    <a-checkbox
                      :defaultChecked="true"
                      @change="onchangeNilaiTf"
                      :checked="checkTransferValue"
                      >Transfer value according to remaining balance</a-checkbox
                    >
                    <a-input-number
                      :min="0.1"
                      :max="sisa_tf"
                      class="m-display-block"
                      v-decorator="[
                        'value_transferan',
                        {
                          rules: [{ required: true }],
                          initialValue: temp_sisa_tf,
                        },
                      ]"
                      :disabled="disableNilaiTf"
                    ></a-input-number>
                  </a-form-item>

                  <a-form-item label="Note">
                    <a-textarea
                      placeholder="Write the note here ... "
                      :rows="4"
                      v-decorator="[
                        'catatan',
                        { rules: [{ required: false }] },
                      ]"
                    />
                  </a-form-item>
                </a-row>
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button
                    @click="handleActionConfirm"
                    block
                    type="primary"
                    html-type="submit"
                    >Save</a-button
                  >
                </a-form-item>
              </a-form>
            </template>
          </a-card> -->
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <!-- <a-collapse :class="getScreen ? 'margin-top' : ''" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Transfer Receipt</h4>
              </div>
              <ul class="m-list-wrapper bordered">
                <li
                  v-for="(dbt, index) in data.detailBuktiTransfer"
                  :key="index"
                >
                  <div
                    slot="title"
                    class="m-display-flex space-between align-middle nowrap"
                  >
                    <h4 class="margin-remove m-text-dots">
                      {{ dbt.tgl_tf }} | {{ dbt.user_tf }}
                    </h4>
                    <a-upload
                      class="upload-custom"
                      :fileList="dbt.fileList"
                      @preview="handlePreview"
                    ></a-upload>
                    <a-modal
                      :visible="previewVisible"
                      :footer="null"
                      @cancel="handleCancel"
                    >
                      <div class="margin-top"></div>
                      <a-divider class="margin-small" />
                      <img
                        alt="example"
                        style="width: 100%"
                        :src="previewImage"
                      />
                    </a-modal>
                  </div>
                  <div class="m-display-flex space-between align-middle">
                    <p slot="description">
                      {{ dbt.currency + ". " + dbt.value_tf }}
                    </p>
                  </div>
                </li>
              </ul>
            </a-collapse-panel>
          </a-collapse> -->
          <a-collapse :class="getScreen ? 'margin-top' : ''" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status :status="data.last_status" />
                  <!-- <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="undo" />
                  </a-button> -->
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">Pembuat - {{data.header.user_creator}}</div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">
                      {{
                        moment(data.header.created_date).format(
                          getDefaultDateFormat
                        )
                      }}
                    </h4>
                    <span
                      class="m-text-small"
                      v-if="data.header.description"
                      >{{ data.header.description }}</span
                    >
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  v-for="workflow in data.status"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">
                    {{ workflow.actor }} - {{ workflow.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove" v-if="workflow.tanggal_aksi">
                      {{
                        moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                      }}
                    </h4>
                    <span class="m-text-small" v-if="workflow.remark">{{
                      workflow.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Related Document</h4>
              </div>

              <a-list
                itemLayout="horizontal"
                :dataSource="data.dokumen_terkait"
              >
                <Empty
                  v-if="
                    data.dokumen_terkait
                      ? data.dokumen_terkait.length <= 0
                      : data.dokumen_terkait
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <a @click="handleViews(item)"
                        >{{ item.header }} | {{ item.tlc }}</a
                      >
                      <Status
                        :class="!getScreen ? 'margin-remove' : ''"
                        :status="item.status"
                      />
                    </div>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                      v-if="item.no_manifest"
                    >
                      <span>{{ item.no_manifest }}</span>
                    </div>
                    <div slot="description" v-if="item.tgl_mulai_dinas">
                      <span
                        >{{
                          moment(
                            item.tgl_mulai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}
                        -
                        {{
                          moment(
                            item.tgl_selesai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}</span
                      >
                    </div>
                    <div slot="description">
                      <div class="m-width-full">
                        <a-tooltip
                          class="ant-tooltip-inner"
                          placement="top"
                          :title="
                            item.deskripsi
                              ? item.deskripsi
                              : 'Tidak ada deskripsi'
                          "
                        >
                          <span class="ant-description-ellipses">{{
                            item.deskripsi
                              ? item.deskripsi
                              : "Tidak ada deskripsi"
                          }}</span>
                        </a-tooltip>
                      </div>
                    </div>
                    <div
                      slot="title"
                      v-if="
                        item.estimated_value && item.rest_api !== 'supplier'
                      "
                    >
                      <span class="m-timeline-title">{{
                        formatCurrency(item.currency, item.estimated_value)
                      }}</span>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </div>

    <!-- <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="reload" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal> -->
  </div>
</template>

<script>
import Axios from "axios";
import { mapGetters, mapActions } from "vuex";
import Status from "@/components/Status.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import lottie from "vue-lottie";
import notfound from "@/assets/anim/404.json";
import moment from "moment";
import _ from "lodash";
import ACol from "ant-design-vue/es/grid/Col";

export default {
  name: "RefundPaymentManifest",
  components: {
    ACol,
    Status,
    notfound,
    "m-anim": lottie,
  },
  props: ["id", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute],
  data() {
    return {
      data:{
        header:{},
        total: {
          subTotal: "",
          grandTotal: "",
          nilaiPajak: "",
          refundTotal:0,
        },
      },
      loading:{
        page:false
      },
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      tableData: [],
      tableDataTemp: [],
      search: undefined,
      dtabel: [],
      dtemptabel: [],
      dlist: [],
    };
  },
  created() {
  },
  beforeCreate() {
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStandartFormatDate",
      "getDefaultDateFormat",
      "getDateTimeFormat",
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          key: "no",
          scopedSlots: { customRender: "no" },
          width: 50,
        },
        {
          title: "Item Name",
          width: 200,
          key: "item_name",
          scopedSlots: { customRender: "item_PN" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "PP Detil",
          width: 200,
          key: "ppdtl",
          scopedSlots: { customRender: "ppdtl" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "Quantity",
          key: "quantity",
          width: 100,
          scopedSlots: { customRender: "quantity" },
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },

        {
          title: "Unit Price",
          key: "unit_price",
          scopedSlots: { customRender: "unit_price" },
          width: 100,
        },
        {
          title: "Amount",
          key: "amount",
          scopedSlots: { customRender: "amount" },
          width: 100,
        },
      ];
      return kolom;
    },

    // searching() {
    //   if (this.search) {
    //     this.tableData = this.tableData.filter(
    //       (obj) =>
    //         obj.item_name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
    //     );
    //   }

    //   if (!this.search) {
    //     this.tableData = this.tableDataTemp;
    //   }

    //   return this.tableData;
    // },
    // getLastStatusShipment() {
    //   if (this.status_shipment) {
    //     if (this.status_shipment.length !== 0) {
    //       if (
    //         this.status_shipment[this.status_shipment.length - 1].deli_sts ===
    //         "Received"
    //       ) {
    //         return false;
    //       } else {
    //         return true;
    //       }
    //     } else {
    //       return true;
    //     }
    //   } else {
    //     return true;
    //   }
    // },
    // getMainStatus() {
    //   if (this.data.status.length !== 0) {
    //     return this.data.status[this.data.status.length - 1].status;
    //   }
    // },
    // getShippingflag() {
    //   return this.data.shipping_flag;
    // },
  },
  methods: {
    moment,
    fetchManifest() {
      this.loading.page = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "payment_refund",
        params: {
          tlc: this.getAuth.username,
          id_manifest: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.data.header= response.data.header[0];
          this.data.dokumen_terkait= response.data.dokumen_related;
          this.tableData = response.data.dtl;
          this.tableDataTemp = response.data.dtl;

          this.dtabel = [];
          this.dtemptabel = [];
          this.dlist = [];
          let temptotal = 0;
          let tempgrandtotal = 0;
          for (let index = 0; index < this.tableData.length; index++) {
            const element = this.tableData[index];
            if (this.tableData[index].kategori == "0") {
              this.dtabel.push(element);
              this.dtemptabel.push(element);
              temptotal += this.tableData[index].jumlah*this.tableData[index].harga;
            } else {
              this.dlist.push(element);
              temptotal
            }
            tempgrandtotal += this.tableData[index].jumlah*this.tableData[index].harga;
          }
          this.data.total.subTotal = temptotal;
          this.data.total.grandTotal =tempgrandtotal;

          this.loading.page = false;
        })
        .catch((err) => {
          if (!err.response) {
            // let responses = Object.assign({}, err.response.data);
            // this.displayMessageValue("error", responses);
            // this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.loading.page = false;
            this.$router.push({ name: "beranda" });
          }
        });
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },

    // addLampiran(e) {
    //   e.stopPropagation();
    //   this.visibleLampiran = !this.visibleLampiran;
    // },

    // cancelLampiran() {
    //   this.fileListModalLampiran = [];
    //   this.formLampiran.resetFields();
    // },

    // handleUploadLampiran() {
    //   this.formLampiran.validateFields((err, values) => {
    //     if (err) {
    //       this.displayMessage("form-warning");
    //       this.formLampiran.return;
    //     }
    //     if (values.file_list_lampiran.fileList.length == 0) {
    //       this.displayMessage("form-warning");
    //       return;
    //     }

    //     let formData = new FormData();
    //     formData.append("id_manifest", this.id);
    //     formData.append("fungsi", values.fungsi);
    //     formData.append("jenis", values.jenis);
    //     formData.append("tlc", this.getAuth.username);
    //     formData.append("nama_document", values.file_list_lampiran.file);

    //     Axios({
    //       method: "post",
    //       url: this.$serviceUrl + "addendum/lampiran",
    //       processData: false,
    //       data: formData,
    //       auth: {
    //         username: this.getAuth.username,
    //         password: this.getAuth.password,
    //       },
    //       headers: {
    //         "Content-Type": "application/json",
    //         "X-API-KEY": this.getAuth.apikey,
    //       },
    //     })
    //       .then((response) => {
    //         this.displayMessage("success-upload");
    //         this.visibleLampiran = !this.visibleLampiran;
    //         this.$router.go();
    //       })
    //       .catch((err) => {
    //         console.log("error : " + err);
    //       });
    //   });
    // },
    // beforeUpload(file) {
    //   const FileSize = file.size / 1024 / 1024;
    //   if (FileSize > 5) {
    //     this.displayMessage("large-file-5mb");
    //   } else {
    //     if (this.data.jenis === "Transfer") {
    //       this.fileList.push(file);
    //     } else {
    //       this.fileListLampiran.push(file);
    //     }
    //     return false;
    //   }
    // },
    // beforeUploadModal(file) {
    //   const FileSize = file.size / 1024 / 1024;
    //   if (FileSize > 5) {
    //     this.displayMessage("large-file-5mb");
    //   } else {
    //     if (this.data.jenis === "Transfer") {
    //       this.fileListModal.push(file);
    //     } else {
    //       this.fileListModalLampiran.push(file);
    //     }
    //     return false;
    //   }
    // },
    // handleRemove(file) {
    //   if (this.data.jenis === "Transfer") {
    //     const index = this.fileList.indexOf(file);
    //     const newFileList = this.fileList.slice();
    //     newFileList.splice(index, 1);
    //     this.fileList = newFileList;
    //   } else {
    //     const index = this.fileListLampiran.indexOf(file);
    //     const newFileList = this.fileListLampiran.slice();
    //     newFileList.splice(index, 1);
    //     this.fileListLampiran = newFileList;
    //   }
    // },
    // handleRemoveModal(file) {
    //   if (this.data.jenis === "Transfer") {
    //     const index = this.fileListModal.indexOf(file);
    //     const newFileList = this.fileListModal.slice();
    //     newFileList.splice(index, 1);
    //     this.fileListModal = newFileList;
    //   } else {
    //     const index = this.fileListModalLampiran.indexOf(file);
    //     const newFileList = this.fileListModalLampiran.slice();
    //     newFileList.splice(index, 1);
    //     this.fileListModalLampiran = newFileList;
    //   }
    // },
    // onchangeNilaiTf(e) {
    //   this.disableNilaiTf = e.target.checked;
    //   if (e.target.checked) {
    //     this.cek_value = 1;
    //     this.checkTransferValue = true;
    //     this.form.setFieldsValue({ value_transferan: this.sisa_tf });
    //   } else {
    //     this.cek_value = 0;
    //     this.checkTransferValue = false;
    //   }
    // },

    handlePreview(url) {
        window.open(this.$serviceUrl+url, "_blank");
    },

    handleCancel() {
      this.previewVisible = false;
    },

    // handleDownload(item) {
    //   // if (item.source === "simfoni") {
    //   window.open(this.$serviceUrl + item.link, "_blank");
    //   // } else {
    //   //   window.open(item.link, "_blank");
    //   // }
    // },

    // handleRemoveExisting(id) {
    //   this.confirmMessageValue("confirm-delete", id);
    // },

    // // metede template dari vue antd
    // edit(key) {
    //   this.cacheData = this.tempDataReceive.map((item) => ({ ...item }));
    //   const newData = [...this.tempDataReceive];
    //   const target = newData.filter((item) => key === item.key)[0];
    //   this.editGudangVal = target.gudang_id;
    //   this.editTlcVal = target.tlc;

    //   if (target) {
    //     target.edit = true;
    //     target.editable = true;
    //     this.tempDataReceive = newData;
    //     // this.fullName = newData;
    //   }
    // },
    // handleChange(value, key, column) {
    //   const newData = [...this.tempDataReceive];
    //   const target = newData.filter((item) => key === item.key)[0];
    //   if (target) {
    //     target[column] = value;
    //     this.tempDataReceive = newData;
    //   }
    // },
    // handleSelected(value, key, column, index) {
    //   if (value === undefined) {
    //     const newData = [...this.tempDataReceive];
    //     const target = newData.filter((item) => key === item.key)[0];
    //     if (target) {
    //       // target[column] = dataFilter[0].gudang_nm;
    //       target["gudang_id"] = null;
    //       target["gudang_name"] = null;
    //       target["tlc"] = null;
    //       target["tlc_name"] = null;
    //       this.tempDataReceive = newData;
    //     }
    //   } else {
    //     if (this.usedfor === "gudang") {
    //       let dataFilter = this.getAllGudang.filter(
    //         (obj) =>
    //           obj.gudang_id.toLowerCase().indexOf(value.toLowerCase()) >= 0
    //       );

    //       const newData = [...this.tempDataReceive];
    //       const target = newData.filter((item) => key === item.key)[0];
    //       if (target) {
    //         target[column] = dataFilter[0].gudang_nm;
    //         target["gudang_id"] = value;
    //         this.tempDataReceive = newData;
    //       }
    //     } else {
    //       let dataFilter = this.getAllKaryawan.filter(
    //         (obj) => obj.tlc.toLowerCase().indexOf(value.toLowerCase()) >= 0
    //       );

    //       const newData = [...this.tempDataReceive];
    //       const target = newData.filter((item) => key === item.key)[0];
    //       if (target) {
    //         target[column] = dataFilter[0].tlc_nm;
    //         target["tlc"] = value;
    //         this.tempDataReceive = newData;
    //       }
    //     }
    //   }
    // },
    // cancel(key) {
    //   const newData = [...this.tempDataReceive];
    //   const target = newData.filter((item) => key === item.key)[0];
    //   if (target) {
    //     Object.assign(
    //       target,
    //       this.cacheData.filter((item) => key === item.key)[0]
    //     );
    //     delete target.editable;
    //     target.edit = false;
    //     this.tempDataReceive = newData;
    //   }
    // },
    // save(key) {
    //   const newData = [...this.tempDataReceive];
    //   const target = newData.filter((item) => key === item.key)[0];
    //   if (target) {
    //     target.edit = false;
    //     delete target.editable;
    //     this.tempDataReceive = newData;
    //   }
    // },
    // getDataReceivePost(val) {
    //   this.tempDataReceive = val.map((item, index) => {
    //     return {
    //       key: item.id_dtl,
    //       no: index + 1,
    //       item_pn: item.item_pn,
    //       kd_anggaran: item.kode_anggaran,
    //       dtl_pp_nm: item.nama_dtl_pp,
    //       item_name: item.nama_barang,
    //       quantity: item.jumlah,
    //       satuan: item.satuan,
    //       gudang_name: null,
    //       gudang_id: null,
    //       tlc_name: null,
    //       tlc: null,
    //       edit: false,
    //     };
    //   });
    // },

    // openWindowCopy(link, noResi) {
    //   const me = this;
    //   this.$copyText(noResi).then(
    //     function (e) {
    //       // this.displayMessageValue("success-copy-resi",e.text);
    //       me.displayMessageValue("success-copy-resi", e.text);
    //       window.open(link, "_blank");
    //     },
    //     function (e) {
    //       alert("Can not copy");
    //     }
    //   );
    // },
    // handleSelectedStorage(val) {
    //   if (val !== undefined) {
    //     this.tempDataReceive.map((item) => {
    //       item.gudang_id = val.key;
    //       item.gudang_name = val.label;
    //     });
    //     this.allowEditModal = true;
    //     this.enabledEditDtl = true;
    //   } else {
    //     this.tempDataReceive.map((item) => {
    //       item.tlc = undefined;
    //       item.tlc_name = undefined;
    //       item.gudang_id = undefined;
    //       item.gudang_name = undefined;
    //     });
    //     this.allowEditModal = false;
    //     this.enabledEditDtl = false;
    //   }
    // },

    handleViews(val) {
      if (val.rest_api === "supplier") {
        let namemanifest = null;
        if (this.getNavigation[0].divisi === "Akuntansi") {
          namemanifest = "SpclSupplierManifestAcc";
        } else {
          namemanifest = "manifestPurchasing";
        }
        this.$router.push({
          name: namemanifest,
          params: {
            id: val.id_manifest,
            tlc: this.getAuth.username,
            user_pembuat: val.user_pembuat,
          },
        });
      } else {
        this.handleView(val);
      }
    },

    // handleEdit() {
    //   this.$router.push({
    //     name: "createPo",
    //     params: { id: this.id, type: "revised" },
    //   });
    // },
    // handleRemoveLampiran(item) {
    //   this.pageLoading = true;
    //   const serviceUrl = this.$serviceUrl;
    //   const auth = {
    //     username: this.getAuth.username,
    //     password: this.getAuth.password,
    //     apikey: this.getAuth.apikey,
    //   };
    //   Axios({
    //     method: "delete",
    //     url: serviceUrl + "addendum/lampiran",
    //     processData: false,
    //     data: {
    //       id_addendum_doc: item,
    //     },
    //     auth: {
    //       username: auth.username,
    //       password: auth.password,
    //     },
    //     headers: {
    //       "X-API-KEY": auth.apikey,
    //     },
    //   })
    //     .then((response) => {
    //       this.pageLoading = false;
    //       Event.$emit("refresh", true);
    //       this.displayMessage("success-del");
    //     })
    //     .catch((err) => {
    //       this.pageLoading = false;
    //       let responses = Object.assign({}, err.response.data);
    //       this.displayMessageValue("error", responses);
    //     });
    // },
    // onChangeStatus(val) {
    //   if (val === "Transferred") {
    //     this.reqFileTf = true;
    //   }
    // },
    // handleActionConfirm() {
    //   this.confirmMessage("confirm-save");
    // },
    // handleAction() {
    //   if (this.data.jenis === "Transfer") {
    //     this.form.validateFields((err, values) => {
    //       if (err) {
    //         return;
    //       }

    //       if (values.value_transferan < 1) {
    //         this.displayMessage("form-warning");
    //         return;
    //       }
    //       let formData = new FormData();
    //       formData.append("tlc", this.getAuth.username);
    //       formData.append("id_manifest", this.id);
    //       formData.append("file_transfer", values.file_transfer.file);
    //       formData.append("remark", values.catatan);
    //       formData.append("status", "Transferred");
    //       formData.append(
    //         "tgl_tf",
    //         moment(values.tgl_tf).format(this.getStandartFormatDate)
    //       );

    //       // if (this.checkTransferValue) {
    //       //   //formData.append("cek_value", 1);
    //       //   formData.append("value_tf", 0);
    //       // } else {
    //       //ormData.append("cek_value", 0);
    //       formData.append("value_tf", values.value_transferan);
    //       //}

    //       Axios({
    //         method: "post",
    //         url: this.$serviceUrl + "other_income/approval",
    //         data: formData,
    //         auth: {
    //           username: this.getAuth.username,
    //           password: this.getAuth.password,
    //         },
    //         headers: {
    //           "Content-Type": "multipart/form-data",
    //           "X-API-KEY": this.getAuth.apikey,
    //         },
    //       })
    //         .then((response) => {
    //           this.displayMessage("success");
    //           this.$router.go(0);
    //         })
    //         .catch((err) => {
    //           console.log("error : " + err);
    //         });
    //     });
    //   }
    // },
    // handleViewFile: function (item) {
    //   const data = {
    //     id_manifest: item.id_account_pay,
    //     rest_api: "accountpay",
    //   };
    //   this.handleView(data);
    // },
  },
  mounted() {
    this.fetchManifest();
    // this.fetchShipment();
    // Event.$on("confirmMessageDelete", this.handleRemoveLampiran);
    // Event.$on("refresh", this.fetchManifest);
    // Event.$on("confirmMessageReturn", this.handleAction);
  },
  beforeDestroy() {
    // Event.$off("confirmMessageDelete", this.handleRemoveLampiran);
    // Event.$off("refresh", this.fetchManifest);
    // Event.$off("confirmMessageReturn", this.handleAction);
  },
  watch: {
    // id() {
    //   if (this.id) {
    //     this.fetchManifest();
    //     this.form = this.$form.createForm(this);
    //     this.fileList = [];
    //     this.checkTransferValue = true;
    //     this.disableNilaiTf = true;
    //     this.reqFileTf = true;
    //     this.search = "";
    //   }
    // },
    search() {
      if (this.search) {
        this.dtabel = this.dtemptabel.filter(
          (obj) =>
            obj.nama_item.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (!this.search) {
        this.dtabel = this.dtemptabel;
      }
    },
  },
};
</script>

<style></style>
